module.exports = {
  query: gql`
    query HealthConsent($slug: String!, $locale: SiteLocale) {
      healthConsent(filter: { slug: { eq: $slug } }, locale: $locale) {
        title
        content
        publishedAt: _publishedAt
      }
      fallback: healthConsent(filter: { slug: { eq: $slug } }, locale: en) {
        title
        content
        publishedAt: _publishedAt
      }
    }
  `,
}
